(function ($, Drupal, drupalSettings) {
  Drupal.behaviors.fixHeight = {
    attach: function (context, settings) {
      $('body', context).once('fixHeight').each(function () {
        let vh = window.innerHeight * 0.01;
        document.documentElement.style.setProperty('--vh', `${vh}px`);

        window.addEventListener('resize', () => {
          let vh = window.innerHeight * 0.01;
          document.documentElement.style.setProperty('--vh', `${vh}px`);
        });
      });
    }
  }
})(jQuery, Drupal, drupalSettings);
